var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VDBaseTemplate',[_c('ExplorerSearchFormAndTable',{attrs:{"userOnMobile":_vm.userOnMobile,"selectedRecordsLimit":_vm.selectedRecordsLimit,"title":_vm.title,"logo":_vm.logo,"endpoint":_vm.endpoint,"rowIdentifier":'Id'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }